// @flow

import React from 'react';
import type { Node } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button } from '@riseart/common';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';

import {
  enquireFormCls,
  enquireFormSectionCls,
  enquireFormSectionCenteredCls,
} from 'shared_components/forms/enquire/Form.less';

type Props = {
  onClose: Function,
  message?: Node,
};

/**
 * EnquireSuccessSection
 *
 * @param {Props} props
 * @returns {Node}
 */
export const EnquireSuccessSection = ({ message, onClose }: Props): Node => (
  <div className={enquireFormCls}>
    <div className={enquireFormSectionCls}>
      {message || (
        <FormattedMessage id="forms.emailEnquire.success">
          {(successText: string) => successText}
        </FormattedMessage>
      )}
    </div>
    <FormattedMessage
      id="forms.emailEnquire.advisorsContactDescription"
      values={{
        advisorPhone: LocalizedConfig.get('contact.advisor.phone'),
        strong: (chunks) => <strong>{chunks}</strong>,
      }}
    >
      {(successMessage: string) => <div className={enquireFormSectionCls}>{successMessage}</div>}
    </FormattedMessage>
    <div className={classNames(enquireFormSectionCls, enquireFormSectionCenteredCls)}>
      <Button type="primary" size="default" onClick={onClose}>
        <FormattedMessage id="forms.common.close">{(close: string) => close}</FormattedMessage>
      </Button>
    </div>
  </div>
);
